import { AnswersProviders } from '../answers/interfaces'
import { QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { provinces } from './common-steps'
import { chooseBrands, choosePhoneOs, currentProviderMobile } from './mobile-steps'

export const provincesStepPhoneSearch = {
  ...provinces,
  next: Steps.CHOOSE_PHONE_OS,
}

export const provincesStepPhoneSearchWithCurrentProvider = {
  ...provincesStepPhoneSearch,
  next: Steps.CURRENT_PROVIDER_MOBILE_PHONE_SEARCH,
}

export const currentProviderMobilePhoneSearch: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE_PHONE_SEARCH,
  next: Steps.CHOOSE_PHONE_OS,
}

export const choosePhoneOsPhoneSearch: ScenarioStep = {
  ...choosePhoneOs,
  clears: [Steps.CHOOSE_PREFERRED_DEVICES_BRANDS],
  question: 'choose-phone-os_question',
  tip: 'choose-phone-os_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS,
  answers: [
    { id: 'all', text: 'common_all', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS },
    { id: 'ios', text: 'common_ios', next: Steps.CHOOSE_PHONE_CONDITION },
    { id: 'android', text: 'common_android', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_ANDROID },
    { id: 'proprietary', text: 'choose-phone-os_proprietary', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_PROPRIETARY },
  ],
}

export const chooseBrandsAndroidPhoneSearch: ScenarioStep = {
  id: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_ANDROID,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-preferred-devices-brands_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_CONDITION,
  answersProvider: { provider: AnswersProviders.PHONES_BRANDS, options: { os: 'android' } },
  answers: [],
}

export const chooseBrandsProprietaryPhoneSearch: ScenarioStep = {
  id: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_PROPRIETARY,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-preferred-devices-brands_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_CONDITION,
  answersProvider: { provider: AnswersProviders.PHONES_BRANDS, options: { os: 'proprietaryos' } },
  answers: [],
}

export const chooseBrandsPhoneSearch = {
  ...chooseBrands,
  next: Steps.CHOOSE_PHONE_CONDITION,
}

export const choosePhoneCondition: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_CONDITION,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-phone-condition_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_FROM_LIST,
  answers: [
    { id: 'all', text: 'common_all' },
    { id: 'new', text: 'common_new' },
    { id: 'refurbished', text: 'common_refurbished' },
  ],
}
